<div class="sticky-bar__first" [ngClass]="{'sticky-bar__first--hide-mobile': hideMobile}">
    <ng-content></ng-content>
</div>
